import axios from '@/utils/request';

// 获取当前登录用户的基本信息
export const getUserInfo = (data: any) => {
  return axios.request({
    url: 'User/GetUserInfo',
    method: 'GET',
    params: data,
  });
};

// 更新用户基本信息
export const updateUserInfo = (data: any) => {
  return axios.request({
    url: 'User/UpdateUserInfo',
    method: 'POST',
    data,
  });
};

// 更新用户密码
export const updateUserPassword = (data: any) => {
  return axios.request({
    url: 'User/UpdatePassword',
    method: 'POST',
    data,
  });
};

// 更新用户头像
export const updateAvatar = (data: any) => {
  return axios.request({
    url: 'User/UpdateAvatar',
    method: 'POST',
    headers: { 'Content-Type': 'multipart/form-data' },
    data,
  });
};

// 获取用户学习统计
export const getLearningStatistics = (data: any) => {
  return axios.request({
    url: 'User/GetLearningStatistics',
    method: 'GET',
    params: data,
  });
};

// 获取用户学习记录
export const getLearningRecords = (data: any) => {
  return axios.request({
    url: 'User/GetLearningRecords',
    method: 'GET',
    params: data,
  });
};

// 用户上线 每分钟调用一次
export const online = (data: any) => {
  const config: any = {
    url: 'User/Online',
    method: 'POST',
    params: data,
    showLoading: false,
  };
  return axios.request(config);
};
